import React, { useState } from 'react';
import { useCurrency } from '../contexts/CurrencyContext';
import CurrencySelector from './CurrencySelector';
import './FlightInput.css';

interface FlightInputProps {
  onSubmit: (flightNumber: string, basePrice?: number) => void;
  loading: boolean;
}

const FlightInput: React.FC<FlightInputProps> = ({ onSubmit, loading }) => {
  const [flightNumber, setFlightNumber] = useState('');
  const [basePrice, setBasePrice] = useState('');
  const { currency, currencyInfo } = useCurrency();

  const submitForm = () => {
    if (flightNumber.trim() && !loading) {
      const price = basePrice.trim() ? parseFloat(basePrice) : undefined;
      onSubmit(flightNumber.trim(), price);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    submitForm();
  };

  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    submitForm();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !loading && flightNumber.trim()) {
      e.preventDefault();
      submitForm();
    }
  };

  return (
    <div className="flight-input-container">
      <form onSubmit={handleSubmit} className="flight-input-form">
        <div className="input-row">
          <div className="input-group">
            <div className="input-with-prompt">
              <input
                id="flightNumber"
                type="text"
                value={flightNumber}
                onChange={(e) => setFlightNumber(e.target.value.toUpperCase())}
                onKeyDown={handleKeyDown}
                disabled={loading}
                className="flight-input"
              />
              <div className={`input-prompt ${flightNumber ? 'hidden' : ''}`}>
                <span className="prompt-label">Flight Number</span>
                <span className="prompt-example"> e.g., FR1234, TR29, F91234, U2 456</span>
              </div>
            </div>
          </div>
          <div className="input-group">
            <div className="input-with-prompt">
              <input
                id="basePrice"
                type="text"
                value={basePrice}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only numbers and decimal point
                  if (value === '' || /^\d*\.?\d*$/.test(value)) {
                    setBasePrice(value);
                  }
                }}
                onKeyDown={handleKeyDown}
                disabled={loading}
                className="flight-input"
                inputMode="decimal"
              />
              <div className={`input-prompt ${basePrice ? 'hidden' : ''}`}>
                <span className="prompt-label">Base Price ({currencyInfo?.symbol || currency})</span>
                <span className="prompt-example"> e.g., 29.99</span>
                <span className="optional-label"> Optional</span>
              </div>
            </div>
          </div>
          <button 
            type="button" 
            disabled={loading || !flightNumber.trim()} 
            className="submit-button"
            onClick={handleButtonClick}
          >
            {loading ? 'Analyzing...' : "What's the Verdict?"}
          </button>
        </div>
        <CurrencySelector />
        <p className="disclaimer-text">
          This service is experimental. Please don't rely upon any figures provided.
        </p>
      </form>
    </div>
  );
};

export default FlightInput;

